const navBarSteps = {
  SURVEY: 'survey',
};

export default navBarSteps;
